import { render } from "./Commande_Item.vue?vue&type=template&id=e63e0fb2"
import script from "./Commande_Item.vue?vue&type=script&lang=js"
export * from "./Commande_Item.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__